<div id="vertical-menu" class="menu-wrapper" perfectScrollbar
style="background-color: #F5F5F5;"></div>